import {useState} from 'react'
import {useSelector} from 'react-redux'
import {useFreezableFilter} from 'hooks/useFreezableFilter'
import {getDeviceLayout} from 'modules/meta/selectors'
import {
  getGroupedHotelDetails,
  getIsSearchCompleted,
  getIsSearchHasResults,
  getTotalCountOfResults
} from 'modules/sapiSearch/selectors'
import {getDealFreezeFilter} from 'modules/search/selectors'
import {
  wasDealFreezeEducationBannerCtaClicked,
  wasDealFreezeEducationBannerShownToday
} from 'utils/persistence'

import {useIsHydrated} from '@vio/core/src/utils/react/hooks/useIsHydrated'
import {getUserAlreadyFrozeADealCookie} from '@vio/shared/src/dealFreeze/services/cookies'

export const useDealFreezeEducationBannerEligibility = (): boolean => {
  const isHydrated = useIsHydrated()
  const deviceLayout = useSelector(getDeviceLayout)
  const isFreezableFilterAvailable = useFreezableFilter()
  const isDealFreezeFilterApplied = useSelector(getDealFreezeFilter)
  const isSearchCompleted = useSelector(getIsSearchCompleted)
  const hasResults = useSelector(getIsSearchHasResults)
  const totalResultsCount = useSelector(getTotalCountOfResults)
  const {greatDeals} = useSelector(getGroupedHotelDetails)

  const [wasShownToday] = useState(() =>
    wasDealFreezeEducationBannerShownToday()
  )
  const [ctaClicked] = useState(() => wasDealFreezeEducationBannerCtaClicked())
  const [alreadyFrozeADeal] = useState(() =>
    Boolean(getUserAlreadyFrozeADealCookie())
  )

  return Boolean(
    isHydrated &&
      deviceLayout === 'mobile' &&
      isFreezableFilterAvailable &&
      !isDealFreezeFilterApplied &&
      !alreadyFrozeADeal &&
      !ctaClicked &&
      !wasShownToday &&
      isSearchCompleted &&
      hasResults &&
      totalResultsCount > 0 &&
      greatDeals.length > 0
  )
}
